import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import moment from 'moment-mini';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Payment Seal',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/',
      },
      {
        text: 'Payment',
        href: '/adm/opr/payment/seal',
        active: true,
      },
    ],
    form_seal_title: 'Form Payment Seal',
    form_seal_breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/',
      },
      {
        text: 'Payment Seal',
        href: '/adm/opr/payment/seal',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    search: '',
    date_filter: '',
    status_filter: '',
    type_filter: '',
    sortBy: '',
    sortDesc: true,
    fields: [
      {
        key: 'code_payseal',
        label: 'Payment No',
        sortable: true,
      },
      {
        key: 'created_at',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'doc_type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'B/L No',
        sortable: true,
      },
      {
        key: 'shipper',
        label: 'Shipper',
        sortable: true,
      },
      {
        key: 'total_final',
        label: 'Total',
        sortable: true,
      },
      {
        key: 'payment_type',
        label: 'Status',
        sortable: true,
      },
      {
        key: 'aksi',
      },
    ],
    kwitansi_seal: {},
    detail: false,
    list_payment_seal: [],
    form_seal: {
      typepayment: 'Debit',
      currency: 'IDR',
      payment_type: 'payment',
      code_principle: '',
      doc_no: '',
      consignee: '',
      pkp: '',
      id_pay_seal: '',
      container_info: {},
      container_pay: [],
      pay_reference: [],
      containers: [],
      payment: [],
      total: 0,
      pph23: 0,
      ppn10: 0,
      total_final: 0,
    },
  },
};

export const getters = {
  form_seal(state) {
    return state.data.form_seal;
  },
  kwitansi_seal(state) {
    return state.data.kwitansi_seal;
  },
};

export const mutations = {
  changePayment(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchBooking(context, params) {
    let result = await ApiGetRequest(`opr/payment-seal/booking`, params);
    return !result.error ? result.data.object : [];
  },

  async getPriceSealByBooking({ commit }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `opr/payment-seal/harga-seal/${payload.id_booking}`,
      payload.params
    );
    commit('changePayment', {
      loading: false,
    });

    return !result.error ? result.data.object : 0;
  },

  async getListPaymentSeal({ commit, state }) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    if (data.date_filter && data.date_filter.length > 0) {
      params.start_date = data.date_filter[0]
        ? moment(data.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.date_filter[1]
        ? moment(data.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    if (data.type_filter && data.type_filter !== '') {
      params.type_filter = data.type_filter;
    }

    if (data.search_container && data.search_container !== '') {
      params.search_container = data.search_container;
    }

    let result = await ApiGetRequest(`opr/payment-seal`, params);
    commit('changePayment', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async createPaymentSeal({ commit, state, dispatch }) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;

    let result = await ApiPostRequest(`opr/payment-seal`, data.form_seal);
    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async updatePaymentSeal({ commit, state, dispatch }) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;

    let result = await ApiPutRequest(
      `opr/payment-seal/${data.detail.id_pay_seal}`,
      data.form_seal
    );
    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async getPaymentSeal({ commit }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    let result = await ApiDeleteRequest(
      `opr/payment-seal/${payload.doc_no}/payment`
    );

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      commit('changePayment', {
        list_payment_seal: result.data.object,
      });

      return true;
    }

    return false;
  },

  async getDetailPaymentSeal({ commit, state }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/payment-seal/${payload.id}`);

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      let resultObj = result.data.object;

      commit('changePayment', {
        form_seal: {
          ...data.form_seal,
          ...resultObj,
          from_payment: data.form_seal.from_payment,
          payment_type: data.form_seal.payment_type,
        },
      });

      return true;
    }

    return false;
  },

  async getInfoPaymentSeal({ commit }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/payment-seal/${payload.id}`);

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      let resultObj = result.data.object;

      commit('changePayment', {
        detail: resultObj,
        form_seal: resultObj,
      });

      return true;
    }

    return false;
  },

  async getBuktiBayarSeal({ commit }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/payment-seal/${payload.id}/kwitansi`);

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      commit('changePayment', {
        kwitansi_seal: result.data.object,
      });

      return true;
    }

    return false;
  },

  async getBuktiBayarSealNotaBaru({ commit }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `opr/payment-seal/${payload.id}/kwitansi-new`
    );

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      commit('changePayment', {
        kwitansi_seal: result.data.object,
      });

      return true;
    }

    return false;
  },
};
